import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateMultipleProductMetafieldsFromTagGroup",
    title: "Update Multiple Product Metafields From Tag Group",
    description: "Automatically set multiple metafield values based on tag belonging to a Tag Group.",
    example: null,
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductMetafields",
    dataPermissions: ["products"],
    allowPreview: false,
    tags: ["Products", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateMultipleProductMetafieldsFromTagGroup",
                metafieldNamespaceAndKeyEntries: [],
                metafieldType: "single_line_text_field",
                tagGroupPrefix: "",
                removeMetafieldValueWhenTagIsMissing: false,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {

                    // if (rule.settings.metafieldNamespaceAndKey == null || !/^(.+\..+)$/.test(rule.settings.metafieldNamespaceAndKey)) {
                    //     errors["metafieldNamespaceAndKey"] = "Incorrect metafield namespace and key";
                    // }

                    if (rule.settings.metafieldType == null || rule.settings.metafieldType === "") {
                        errors["metafieldType"] = "Metafield type is required";
                    }

                    if (rule.settings.tagGroupPrefix == null || rule.settings.tagGroupPrefix === "") {
                        errors["tagGroupPrefix"] = "Tag group prefix is required";
                    }
                }
            ], createClashingRulesValidationFunctionNew("PRODUCT"));
    }
};

export default ruleDefinition;